import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';

const List = ({ t, offerWorkshops, useStripeFeeMode, ...rest }) => {
	const columns = [
		{
			header: t('SoftwareFeeReport_Franchisee'),
			accessor: 'franchiseeName',
			sortable: true,
			sortKey: 'franchisee'
		},
		{
			header: t('SoftwareFeeReport_Center'),
			accessor: 'center.name',
			sortable: true,
			sortKey: 'center'
		}
	];
	if (!useStripeFeeMode) {
		columns.push({
			header: t('SoftwareFeeReport_Quantity'),
			accessor: 'quantity',
			sortable: true
		});
		if (offerWorkshops) {
			columns.push({
				header: t('SoftwareFeeReport_HalfDaySessionsCount'),
				accessor: 'halfDaySessionsCount',
				sortable: true
			});
			columns.push({
				header: t('SoftwareFeeReport_FullDaySessionsCount'),
				accessor: 'fullDaySessionsCount',
				sortable: true
			});
		}
	}
	columns.push({
		header: t('SoftwareFeeReport_TotalInclTax'),
		accessor: 'totalInclTax',
		cell: (totalInclTax) => ui.formatAmount(totalInclTax),
		sortable: true
	});
	columns.push({
		header: t('SoftwareFeeReport_Tax'),
		accessor: 'tax',
		cell: (tax) => ui.formatAmount(tax),
		sortable: true
	});
	columns.push({
		header: t('SoftwareFeeReport_TotalExclTax'),
		accessor: 'totalExclTax',
		cell: (totalExclTax) => ui.formatAmount(totalExclTax),
		sortable: false
	});

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);
